$(document).ready(function() {
    $(".full-height").height($(document).height() - 60);

    $(window).resize(function() {
        $(".full-height").height($(document).height() - 60);
    });
});

